export const sliderRegistry = {
  announcement: {
    type: "slider",
    autoplay: 2000,
    hoverpause: true,
    gap: 0,
  },

  product: {
    type: "slider",
    perView: 4,
    gap: 16,
    bound: true,
    perSwipe: "|",
    rewind: true,
    breakpoints: {
      1024: { perView: 3 },
      768: { perView: 2 },
      480: { perView: 1 },
    },
  },
  banner: {
    type: "slider",
    perView: 1,
  },
};
